import React, { useEffect, useState } from "react";
import { TrajesContainer } from "../styles";
import { useLocation, useNavigate } from "react-router-dom";
import { ModelCard, ModelGrid, ModelImage, ModelInfo, ModelName, ToggleButtonTrajes } from "./styles";
import { BackToTop, Footer, NavItem, NavMenu } from "../../Inicio/styles";

const Negros = () => {
    const [collapsed, setCollapsed] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            if(window.scrollY > 300) {
                setShowButton(true);
            } else {
                setShowButton(false);
            };
        }
        
        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll)
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior:"smooth"
        })
    };

    useEffect(() => {
                if(collapsed) {
                    document.body.style.overflow = "hidden";
                } else {
                    document.body.style.overflow = "auto";
                }
        
                return () => {
                    document.body.style.overflow = "auto";
                };
            }, [collapsed])
    

    return (
        <>
            <TrajesContainer>
                <p>Trajes negros</p>
                <ToggleButtonTrajes collapsed={collapsed} onClick={() => setCollapsed(!collapsed)}>
                    {collapsed ? "✕" : "☰"}
                </ToggleButtonTrajes>

                <NavMenu collapsed={collapsed}>
                    <NavItem
                        onClick={() => navigate("/")}
                        active = {location.pathname === "/"}
                    >
                        Inicio
                    </NavItem>

                    <NavItem
                        active={location.pathname.startsWith("/trajes")}
                        onClick={() => navigate("/trajes")}
                    >
                        Trajes
                    </NavItem>

                    <NavItem
                        active = {location.pathname.startsWith("/smokings")}
                        onClick={() => navigate("/smokings")}
                    >
                        Smokings
                    </NavItem>

                    <NavItem
                        active = {location.pathname === "/togas"}
                        onClick={() => navigate("/togas")}
                    >
                        Togas
                    </NavItem>
                    <NavItem>
                        <a
                            href="/catalogo-trajes"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Catálogo
                        </a>
                    </NavItem>
                    <NavItem><a href="https://wa.me/5213311407070" target="_blank" rel="noopener noreferrer">Contacto</a></NavItem>
                </NavMenu>
            </TrajesContainer>

            <ModelGrid>
                <ModelCard>
                    <ModelImage 
                        src="/img/Italo.jpg" alt="Italo" 
                        onClick={() => navigate("/trajes/negros/italo")}
                    />
                    <ModelInfo>
                        <ModelName>Italo</ModelName>
                    </ModelInfo>
                </ModelCard>

                <ModelCard>
                    <ModelImage 
                        src="/img/Pinpon.jpg" alt="Ping-pong"
                        onClick={() => navigate("/trajes/negros/pingpong")}
                    />
                    <ModelInfo>
                        <ModelName>Ping-pong</ModelName>
                    </ModelInfo>
                </ModelCard>

                <ModelCard>
                    <ModelImage 
                        src="/img/Mexico.jpg" alt="México"
                        onClick={() => navigate("/trajes/negros/mexico")}
                    />
                    <ModelInfo>
                        <ModelName>México</ModelName>
                    </ModelInfo>
                </ModelCard>
            </ModelGrid>

            <Footer>
                <p>Eleganza Sartoriale</p>
                <p>Guadalajara, Jalisco</p>
                <div>
                    <a href="https://www.instagram.com/renta_de_trajes_mr?utm_source=qr&igsh=MW9pb2VwMnRmeW8zaw==">Intagram</a>
                    <a href="https://www.facebook.com/share/14WVJRCc3W4/">Facebook</a>
                    <a href="https://www.tiktok.com/@rentadetrajesmr?_r=1&_t=ZS-95BqJJ1lF7X">Tik Tok</a>
                </div>
                <div>
                    <p>© 2026 Renta de Trajes MR. Todos los derechos reservados.</p>
                </div>
            </Footer>
            {showButton && (
                <BackToTop onClick={scrollToTop}>
                    ▲
                </BackToTop>
            )}
        </>
    )
};

export default Negros;